import React, { useEffect, useState } from "react";
import { LuUpload } from "react-icons/lu";
import "../DeshBoard.css";
import Switch from "react-input-switch";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEdit } from "@fortawesome/free-solid-svg-icons";
import UploadDoc from "../../../assests/upload.png";
import Document_show from "../../../assests/Document_show.png";
import DetailIcon from "../../../assests/c-detail-icon.png";
import "../PopUp.css";
import { HiOutlinePencil } from "react-icons/hi2";
import { Api, fetchFileWithId } from "../../../services/httpService";
import { url, subscriptionKey } from "../../../constants";
import Loader from "../Loader";
import LoaderModal from "../LoaderModal";
import { IoCheckmarkCircle } from "react-icons/io5";
const FinancialOverviewScreen = (props) => {
  const merchantId = localStorage.getItem("_id");
  const tokenHeader = localStorage.getItem("_token") || "";
  const [companies, setCompanies] = useState([]);
  const [status, setStatus] = useState(null);
  const companyId = Number(props.companyId);

  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    setIsAecbPasswordProtected(false);
    setAecbPassword("");
    setAecbPasswordError("");
  };

  const [guidelines, setguidelines] = useState([]);
  const [uploadedFilesMap, setUploadedFilesMap] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [fileError, setFileError] = useState("");
  const [popUpTitle, setPopUpTitles] = useState("");

  const [showPreview, setShowPreview] = useState(false);
  const [currentPreview, setCurrentPreview] = useState("");
  const [currentPreviewName, setCurrentPreviewName] = useState("");
  const [currentPreviewType, setCurrentPreviewType] = useState("");
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewError, setPreviewError] = useState("");
  const [isAecbPasswordProtected, setIsAecbPasswordProtected] =
    useState(false);
  const [aecbPassword, setAecbPassword] = useState("");
  const [aecbPasswordError, setAecbPasswordError] = useState("");
  const [isRevealingAecbPassword, setIsRevealingAecbPassword] = useState(false);
  const [isAecbPasswordVisible, setIsAecbPasswordVisible] = useState(false);
  const [isAecbPasswordEditable, setIsAecbPasswordEditable] = useState(true);

  const [currentUploadKey, setCurrentUploadKey] = useState("");

  const [uploadStatus, setUploadStatus] = useState({
    "Sales Forecast": false,
    "Existing Liabilities": false,
    "Audited Reports": false,
    "UnAudited Reports": false,
    "AECB Report": false,
    Receivables: false,
    VAT: false,
  });
  const [salesStatus, setSalesStatus] = useState(
    props?.companyData?.salesForecastStatus
  );
  const [existingLiabilitiesStatus, setExistingLiabilitiesStatus] = useState(
    props?.companyData?.existingLiabilitiesStatus
  );
  const [auditedReportsStatus, setAuditedReportsStatus] = useState(
    props?.companyData?.auditedFinancialReportStatus
  );
  const [unAuditedReportsStatus, setUnAuditedReportsStatus] = useState(
    props?.companyData?.unauditedFinancialReportStatus
  );
  const [aecbReportStatus, setAECBReportStatus] = useState(
    props?.companyData?.creditBureauReportStatus
  );
  const [receivablesStatus, setReceivablesStatus] = useState(
    props?.companyData?.customerReceivablesAgeingStatus
  );
  const [vatStatus, setVatStatus] = useState(
    props?.companyData?.vatReturnsStatus
  );

  const tiles = {
    Sales_Forecast: {
      title: "Next 6 month Sales Forecast",
      uploadKey: "Sales Forecast",
      bottomRowText: "This is not applicable for me",
      popUpTitle:
        salesStatus === "UNDER_REVIEW"
          ? "Sales Forecast- Next 6 Months"
          : "Upload Sales Forecast- Next 6 Months",
      switchValue: props?.valueSalesForecast ? 1 : 0,
      switchFunc: () => props?.setValueSalesForecast,
      guidelines: [
        "Upload the sales forecast for the next 6 months.",
        "Ensure the document clearly shows projected figures and relevant details.",
        "Supported format: PDF (max 15MB per file).",
      ],
      docInfoId: 16,
      status: salesStatus,
      allowedFiles: 1,
      allowedSize: 15,
    },
    Existing_Liabilities: {
      title: "Details of Existing Liabilites",
      uploadKey: "Existing Liabilities",
      bottomRowText: "This is not applicable for me",
      popUpTitle:
        existingLiabilitiesStatus === "UNDER_REVIEW"
          ? "Details of Existing Liabilities"
          : "Upload Details of Existing Liabilites",
      guidelines: [
        "Upload the document containing details of your existing liabilities.",
        "Ensure the document clearly lists all liabilities with amounts, lenders, and due dates.",
        "Supported format: PDF (max 15MB per file).",
      ],
      docInfoId: 17,
      status: existingLiabilitiesStatus,
      allowedFiles: 1,
      allowedSize: 15,
    },
    Audited_Reports: {
      title: "Latest Audited Financial Reports",
      uploadKey: "Audited Reports",
      bottomRowText: "This is not applicable for me",
      popUpTitle:
        auditedReportsStatus === "UNDER_REVIEW"
          ? "Latest Audited Financial Reports"
          : "Upload Latest Audited Financial Reports",
      switchValue: props?.valueAuditReport ? 1 : 0,
      switchFunc: () => props?.setValueAuditReport,
      guidelines: [
        "Upload the latest audited financial report for your company.",
        "Supported format: PDF (max 15MB per file).",
      ],
      docInfoId: 18,
      status: auditedReportsStatus,
      allowedFiles: 1,
      allowedSize: 15,
    },
    UnAudited_Reports: {
      title: "Latest Un-Audited Financial Reports",
      uploadKey: "UnAudited Reports",
      bottomRowText:
        " Upload your most recent un-audited financial reports to reflect the latest financial position.",
      popUpTitle:
        unAuditedReportsStatus === "UNDER_REVIEW"
          ? "Latest Un-Audited Financial Reports"
          : "Upload Latest Un-Audited Financial Reports",
      guidelines: [
        "Upload the latest un-audited financial report for your company.",
        "Supported format: PDF (max 15MB per file).",
      ],
      docInfoId: 19,
      status: unAuditedReportsStatus,
      allowedFiles: 1,
      allowedSize: 15,
    },
    AECB_Report: {
      title: " Etihad Credit Bureau (AECB) Reports for Company",
      uploadKey: "AECB Report",
      bottomRowText: "This is not applicable for me",
      popUpTitle:
        aecbReportStatus === "UNDER_REVIEW"
          ? "Etihad Credit Bureau (AECB) Report"
          : "Upload Etihad Credit Bureau (AECB) Report",
      guidelines: [
        "Upload the latest Etihad Credit Bureau (AECB) report for your company.",
        <>
          This report can be obtained from Etihad Credit Bureau website at{" "}
          <a
            href="https://etihadbureau.ae/Business/CreditReport"
            className="viewMore text-decoration-underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Credit Report | Business | Etihad Credit
          </a>
          .
        </>,
        "Supported format: PDF (max 100MB per file).",
      ],
      docInfoId: 20,
      status: aecbReportStatus,
      allowedFiles: 1,
      allowedSize: 100,
    },
    Receivables: {
      title: "  Latest Ageing of Customer Receivables from the Buyer Ecosystem",
      uploadKey: "Receivables",
      bottomRowText: "This is not applicable for me",
      popUpTitle:
        receivablesStatus === "UNDER_REVIEW"
          ? "Latest Ageing of Customer Receivables"
          : "Upload Latest Ageing of Customer Receivables",
      guidelines: [
        "Upload the latest ageing report of customer receivables from your buyer ecosystem.",
        "Supported format: PDF (max 15MB per file).",
      ],
      docInfoId: 21,
      status: receivablesStatus,
      allowedFiles: 1,
      allowedSize: 15,
    },
    VAT: {
      title: "VAT Returns",
      uploadKey: "VAT",
      bottomRowText: "This is not applicable for me",
      popUpTitle:
        vatStatus === "UNDER_REVIEW" ? "VAT Returns" : "Upload VAT Returns",
      switchValue: props?.valueVatReturns ? 1 : 0,
      switchFunc: () => props?.setValueVatReturns,
      guidelines: [
        "Upload the VAT returns for all the relevant quarters in current financial year.",
        "Ensure the document is in the name of the company and includes relevant supply figures and filing period.",
        "Please upload VAT returns for unaudited period.",
        "Supported format: PDF (max 15MB per file).",
      ],
      docInfoId: 23,
      status: vatStatus,
      allowedFiles: 4,
      allowedSize: 15,
    },
  };

  const getAllowedFilesCount = (uploadKey) => {
    const tile = Object.values(tiles).find((t) => t?.uploadKey === uploadKey);
    return tile ? tile.allowedFiles : 1;
  };

  const getAllowedFilesSize = (uploadKey) => {
    const tile = Object.values(tiles).find((t) => t?.uploadKey === uploadKey);
    return tile ? tile.allowedSize : 1;
  };

  // ----------------------------------------
  const fetchCompanies = async () => {
    try {
      setLoading(true);
      const response = await Api("get", `/company/companyList/${merchantId}`);

      if (response && response.body) {
        const filteredCom = response.body.filter((com) => com.id === companyId);

        setSalesStatus(filteredCom?.[0]?.salesForecastStatus);
        setExistingLiabilitiesStatus(
          filteredCom?.[0]?.existingLiabilitiesStatus
        );
        setAuditedReportsStatus(filteredCom?.[0]?.auditedFinancialReportStatus);
        setUnAuditedReportsStatus(
          filteredCom?.[0]?.unauditedFinancialReportStatus
        );
        setAECBReportStatus(filteredCom?.[0]?.creditBureauReportStatus);
        setReceivablesStatus(filteredCom?.[0]?.customerReceivablesAgeingStatus);
        setVatStatus(filteredCom?.[0]?.vatReturnsStatus);
      }
      props.triggerProgressRefresh();
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  //--------------------------------------------------

  useEffect(() => {
    if (companyId) {
      fetchFinDocuments();
    }
  }, [companyId]);

  // Fetch all financial documents for the company
  const fetchFinDocuments = async () => {
    const docInfoIds = [16, 17, 18, 19, 20, 21, 23];
    const companyId = Number(props.companyId);

    // Build query string
    const params = new URLSearchParams({
      companyId: companyId,
      docInfoIds: docInfoIds.join(","),
    }).toString();

    try {
      setLoading(true);
      const response = await Api(
        "get",
        `/documents/getFinancialDocuments?${params}`
      );

      // Extract the array from response
      const docs = Array.isArray(response?.body?.documents)
        ? response.body.documents
        : Array.isArray(response?.data?.documents)
        ? response.data.documents
        : [];

      // Build a map: documentInfoId -> true if any doc exists for that docInfoId
      const uploadedMap = {};
      docs.forEach((doc) => {
        if (doc.documentInfoId) {
          uploadedMap[doc.documentInfoId] = true;
        }
      });

      // Update uploadStatus for each tile
      setUploadStatus((prev) => {
        const updated = { ...prev };
        Object.values(tiles).forEach((tile) => {
          // tile.docInfoId is the key to match with uploadedMapIdentification
          updated[tile.uploadKey] = !!uploadedMap[tile.docInfoId];
        });
        return updated;
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch documents for a specific docInfoId (per tile)
  const fetchDocList = async (docInfoId, uploadKey) => {
    setLoading(true);
    try {
      const response = await Api(
        "get",
        `/documents/getDocListByDocInfoId/${companyId}/COMPANY/${docInfoId}`
      );
      const rawArray =
        response?.body?.data || response?.data?.data || response?.data || [];
      const serverFiles = rawArray.map((doc, idx) => ({
        name: doc.fileName,
        date: doc.docIssueDate ? new Date(doc.docIssueDate).toISOString() : "",
        url: `/documents/download/${doc.fileId}`,
        fileType: doc.fileType,
        fileId: doc.fileId,
        isServerFile: true,
        _k: `${doc.fileId}-${idx}`,
        docId: doc.docId,
        isPasswordProtected: doc.isPasswordProtected,
      }));
      setUploadedFilesMap((prev) => ({
        ...prev,
        [uploadKey]: serverFiles,
      }));
      setCurrentUploadKey(uploadKey);
      setShow(true);
      // handleClose();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
      // handleClose();
    }
  };

  useEffect(() => {
    if (!show || currentUploadKey !== "AECB Report") return;
    const hasProtected = (uploadedFilesMap[currentUploadKey] || []).some(
      (file) => file.isServerFile && file.isPasswordProtected
    );
    setIsAecbPasswordProtected(hasProtected);
    setIsAecbPasswordVisible(false);
    setIsAecbPasswordEditable(!hasProtected);
    if (!hasProtected) {
      setAecbPassword("");
      setAecbPasswordError("");
    }
  }, [show, currentUploadKey, uploadedFilesMap]);

  const handleRevealAecbPassword = async () => {
    const protectedFile = (uploadedFilesMap[currentUploadKey] || []).find(
      (file) => file.isServerFile && file.isPasswordProtected
    );
    if (!protectedFile?.docId) return;
    setIsRevealingAecbPassword(true);
    try {
      const response = await Api(
        "get",
        `/documents/revealDocumentPassword/${protectedFile.docId}`
      );
      const revealedPassword = response?.body?.password;
      if (response?.success && revealedPassword) {
        setIsAecbPasswordProtected(true);
        setAecbPassword(revealedPassword.trim());
        setAecbPasswordError("");
        setIsAecbPasswordVisible(true);
      } else {
        alert("Unable to reveal password.");
      }
    } catch (err) {
      console.error(err);
      alert("Unable to reveal password.");
    } finally {
      setIsRevealingAecbPassword(false);
    }
  };

  const handleFileUpload = (e, uploadKey) => {
    const files = Array.from(e.target.files);
    const validTypes = ["application/pdf"];
    const filtered = files.filter(
      (file) =>
        validTypes.includes(file.type) &&
        file.size <= getAllowedFilesSize(uploadKey) * 1024 * 1024
    );
    if (filtered.length !== files.length) {
      setFileError("Only PDF, PNG, JPG under 5MB are allowed.");
    }
    // Only allow 1 file: if already present, do not add more
    if (
      (uploadedFilesMap[uploadKey] || []).length >
      getAllowedFilesCount(currentUploadKey) //>= here
    ) {
      setFileError("Only one file can be uploaded for this document type.");
      e.target.value = null;
      return;
    }
    const newAllowedFilesCount =
      getAllowedFilesCount(currentUploadKey) -
      (uploadedFilesMap[uploadKey]?.length ?? 0);

    const newFiles = filtered.slice(0, newAllowedFilesCount).map((file) => ({
      name: file.name,
      date: new Date().toISOString(),
      fileObject: file,
      isServerFile: false,
    }));
    e.target.value = null;
    setUploadedFilesMap((prev) => ({
      ...prev,
      [uploadKey]: [...(prev[uploadKey] || []), ...newFiles],
    }));
  };

  const handleDrop = (e, uploadKey) => {
    e.preventDefault();
    e.stopPropagation();
    console.log("Drop event:", uploadKey, getAllowedFilesCount(uploadKey));
    if (
      (uploadedFilesMap[uploadKey] || []).length <=
      getAllowedFilesCount(uploadKey)
    ) {
      const files = Array.from(e.dataTransfer.files);
      const validTypes = ["application/pdf"];
      const filtered = files.filter(
        (file) =>
          validTypes.includes(file.type) &&
          file.size <= getAllowedFilesSize(uploadKey) * 1024 * 1024
      );
      const newAllowedFilesCount =
        getAllowedFilesCount(uploadKey) -
        (uploadedFilesMap[uploadKey]?.length ?? 0);
      const newFiles = filtered.slice(0, newAllowedFilesCount).map((file) => ({
        name: file.name,
        date: new Date().toISOString(),
        fileObject: file,
        isServerFile: false,
      }));
      setUploadedFilesMap((prev) => ({
        ...prev,
        [uploadKey]: [...(prev[uploadKey] || []), ...newFiles],
      }));
    }
  };

  const handleRemoveFile = async (file) => {
    // If it's a local file, just remove from state
    if (!file.isServerFile) {
      setUploadedFilesMap((prev) => ({
        ...prev,
        [currentUploadKey]: (prev[currentUploadKey] || []).filter(
          (f) => f !== file
        ),
      }));
      return;
    }

    // If it's a server file, call the API
    const { docId } = file;
    setLoadingModal(true);
    try {
      const resDeletedFile = await fetch(
        `${url}/documents/deleteDocById/${Number(docId)}`,
        {
          method: "DELETE",
          headers: {
            "Ocp-Apim-Subscription-Key": subscriptionKey,
            Authorization: tokenHeader,
          },
          redirect: "follow",
        }
      );
      await fetchCompanies();
      if (resDeletedFile) {
        // Refresh the file list for this tile
        const tile = Object.values(tiles).find(
          (t) => t.uploadKey === currentUploadKey
        );
        if (tile) {
          // fetchDocList(tile.docInfoId, currentUploadKey);
          setUploadedFilesMap((prev) => ({
            ...prev,
            [currentUploadKey]: (prev[currentUploadKey] || [])?.filter(
              (f) => f?.docId !== docId
            ),
          }));
          await fetchFinDocuments();
        }
      }
      setLoadingModal(false);
    } catch (error) {
      setLoadingModal(false);
      console.error(error);
    }
  };

  // or from env
  // const subscriptionKey = process.env.REACT_APP_APIM_SUBSCRIPTION_KEY;

  const handlePreview = async (fileId, fileName = "", fileType = "") => {
    if (!fileId) return;
    if (currentPreview) {
      URL.revokeObjectURL(currentPreview);
    }
    setShow(!show);
    setShowPreview(true);
    setPreviewLoading(true);
    setPreviewError("");
    setCurrentPreview("");
    setCurrentPreviewName(fileName || fileId);
    console.log("fileType in handlePreview", fileType);
    setCurrentPreviewType(fileType || "");
    setLoadingModal(true);
    try {
      // const fileRes = await fetch(`${url}/files/${fileId}`, {
      //   method: "GET",
      //   headers: {
      //     "Ocp-Apim-Subscription-Key": subscriptionKey,
      //     Authorization: tokenHeader,
      //   },
      //   redirect: "follow",
      // });
      const response = await fetchFileWithId(fileId);
      console.log(response, "response in getFilePreview");

      if (response) {
        const blob =
          response instanceof Blob ? response : await response.blob();
        const previewUrl = URL.createObjectURL(blob);
        setCurrentPreview(previewUrl);
        setPreviewLoading(false);
      } else {
        setPreviewError("Unable to load preview.");
        setLoadingModal(false);
        setPreviewLoading(false);
      }

      // if (response) {
      //   const blob = await fileRes.blob();
      //   let mime = blob.type || fileType || "";
      //   setCurrentPreviewType(mime);

      //   const reader = new FileReader();
      //   reader.onloadend = () => {
      //     const base64data = reader.result;
      //     setCurrentPreview(previewUrl);
      //     setPreviewLoading(false);
      //   };
      //   reader.readAsDataURL(blob);
      // } else {
      //   setPreviewError("Unable to load preview.");
      //   setLoadingModal(false);
      //   setPreviewLoading(false);
      // }
    } catch (err) {
      setPreviewError("Unable to load preview.");
      setPreviewLoading(false);
      console.error(err);
    } finally {
      setLoadingModal(false);
      setPreviewLoading(false);
    }
  };

  const closePreview = () => {
    if (currentPreview) URL.revokeObjectURL(currentPreview);
    setShow(!show);
    setShowPreview(false);
    setCurrentPreview("");
    setCurrentPreviewName("");
    setCurrentPreviewType("");
    setPreviewLoading(false);
    setPreviewError("");
    setLoadingModal(false);
  };

  const getDocumentStatusNode = (status) => {
    if (status === "SUBMITTED") {
      return (
        <div className="note-btn comp-btn w-100">
          {" "}
          <span>
            <IoCheckmarkCircle />
            Submitted{" "}
          </span>{" "}
        </div>
      );
    } else if (status === "IN_PROGRESS") {
      return (
        <div className="note-btn w-100">
          <span className="text-primary">In Progress</span>{" "}
        </div>
      );
    } else if (status === "NOT_STARTED") {
      return (
        <div className="note-btn w-100">
          <span>Not Started</span>{" "}
        </div>
      );
    } else if (status === "UNDER_REVIEW") {
      return (
        <div className="note-btn w-100">
          <span>Under Review</span>{" "}
        </div>
      );
    } else if (status === "APPROVED") {
      return (
        <div className="note-btn w-100">
          <span className="text-success">Approved</span>{" "}
        </div>
      );
    } else if (status === "REJECTED") {
      return (
        <div className="note-btn w-100">
          {" "}
          <span style={{ fontSize: "16px", color: "#B22D2D" }}>
            Rejected
          </span>{" "}
        </div>
      );
    } else if (status === "NEEDS_ATTENTION") {
      return (
        <div className="note-btn w-100 ">
          <span style={{ fontSize: "16px" }}>Needs Attention</span>{" "}
        </div>
      );
    } else {
      return (
        <div className="note-btn w-100">
          <span>Not Started</span>{" "}
        </div>
      );
    }
  };

  const handleSubmit = async (uploadKey) => {
    const isAecbUpload = uploadKey === "AECB Report";
    const hasServerFileForCurrent = (uploadedFilesMap[uploadKey] || []).some(
      (f) => f.isServerFile
    );
    const canSubmitWithoutFile =
      isAecbUpload &&
      hasServerFileForCurrent &&
      (!isAecbPasswordProtected || aecbPassword.trim());
    if (
      isAecbUpload &&
      isAecbPasswordProtected &&
      !aecbPassword.trim()
    ) {
      setAecbPasswordError("Password is required.");
      return;
    }
    const files = (uploadedFilesMap[uploadKey] || []).filter(
      (f) => !f.isServerFile
    );
    if (!files.length && !canSubmitWithoutFile) return;
    setLoadingModal(true);
    const tile = Object.values(tiles).find((t) => t.uploadKey === uploadKey);
    try {
      let response;
      if (isAecbUpload && !files.length) {
        const targetDoc = (uploadedFilesMap[uploadKey] || []).find(
          (f) => f.isServerFile
        );
        if (!targetDoc?.docId) return;
        const payload = {
          docId: targetDoc.docId,
          isPasswordProtected: !!isAecbPasswordProtected,
          ...(isAecbPasswordProtected
            ? { docPassword: aecbPassword.trim() }
            : {}),
        };
        response = await Api(
          "put",
          `/documents/updateDocumentPassword`,
          payload
        );
      } else {
        const formData = new FormData();
        formData.append("documentInfoId", tile.docInfoId);
        if (isAecbUpload) {
          formData.append(
            "isPasswordProtected",
            isAecbPasswordProtected ? "true" : "false"
          );
          if (isAecbPasswordProtected) {
            formData.append("docPassword", aecbPassword);
          }
        }
        formData.append("entityType", "COMPANY");
        formData.append("entityId", companyId);
        formData.append("merchantId", merchantId);
        formData.append("docCountry", "UAE");
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const dd = String(today.getDate()).padStart(2, "0");
        const formattedDate = `${yyyy}-${mm}-${dd}`;
        formData.append("docIssueDate", formattedDate);
        files.forEach((f) => formData.append("files", f.fileObject));
        response = await Api(
          "post",
          `/documents/uploadOrUpdateDocuments`,
          formData,
          true
        );
      }
      await fetchCompanies();
      if (response?.success) {
        // Refresh the file list for this tile
        // fetchDocList(tile.docInfoId, uploadKey);
        setUploadStatus((prev) => ({ ...prev, [uploadKey]: true }));
        // setShow(false);
        handleClose();
      }
      setLoadingModal(false);
    } catch (err) {
      setLoadingModal(false);
      alert("Upload failed. Please try again.");
    }
  };
  const getDaysAgoText = (input) => {
    // Handle both Date objects and date strings
    const uploadedDate = input instanceof Date ? input : new Date(input);
    if (isNaN(uploadedDate)) return "Invalid date";

    const now = new Date();
    const timeDiff = now - uploadedDate;
    const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

    if (daysDiff === 0) return "Uploaded today";
    if (daysDiff > 0)
      return `Uploaded ${daysDiff} day${daysDiff > 1 ? "s" : ""} ago`;
    return `Uploaded in ${Math.abs(daysDiff)} day${
      Math.abs(daysDiff) > 1 ? "s" : ""
    }`;
  };

  const handleNotApplicableSwitch = async (docId, value) => {
    setLoading(true);
    try {
      const res = await Api(`post`, `/documents/changeMandatoryFlag`, {
        companyId: companyId,
        documentInfoId: docId,
        isNotMandatory: value,
      });
      if (res.body) {
        await fetchFinDocuments();

        setSalesStatus(res?.body?.salesForecastStatus);
        setExistingLiabilitiesStatus(res?.body?.existingLiabilitiesStatus);
        setAuditedReportsStatus(res?.body?.auditedFinancialReportStatus);
        setUnAuditedReportsStatus(res?.body?.unauditedFinancialReportStatus);
        setAECBReportStatus(res?.body?.creditBureauReportStatus);
        setReceivablesStatus(res?.body?.customerReceivablesAgeingStatus);
        setVatStatus(res?.body?.vatReturnsStatus);
      }
      props.triggerProgressRefresh();
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  const hasLocalFilesForCurrent =
    (uploadedFilesMap[currentUploadKey] || []).some((f) => !f.isServerFile);
  const hasServerFilesForCurrent =
    (uploadedFilesMap[currentUploadKey] || []).some((f) => f.isServerFile);
  const canSaveAecbPasswordOnly =
    currentUploadKey === "AECB Report" &&
    hasServerFilesForCurrent &&
    (!isAecbPasswordProtected || aecbPassword.trim());
  const hasProtectedAecbServerFile =
    currentUploadKey === "AECB Report" &&
    (uploadedFilesMap[currentUploadKey] || []).some(
      (file) => file.isServerFile && file.isPasswordProtected
    );

  if (loading) {
    return (
      <div className="company-info-box">
        <Loader />
      </div>
    );
  } else {
    return (
      <div>
        {/* Tiles */}
        {/* Company Info Tiles Section */}

        <div className="company-info-box">
          <div className="container">
            <div className="row">
              {Object.entries(tiles).map((singleTile, index) => {
                const uploadKey = singleTile[1].uploadKey;
                const isSwitchCompleted =
                  (uploadKey === "Sales Forecast" &&
                    props?.valueSalesForecast === 1) ||
                  (uploadKey === "Audited Reports" &&
                    props?.valueAuditReport === 1) ||
                  (uploadKey === "VAT" && props?.valueVatReturns === 1);

                return (
                  <div className="col-12" key={index}>
                    <div
                      style={{ borderRadius: "12px" }}
                      className="company-info-inner company-overview-box d-flex align-items-start flex-wrap p-3 mb-3"
                    >
                      <div className="info-box d-flex">
                        <div className="img-box me-3 d-flex align-items-center justify-content-center">
                          <img
                            src={DetailIcon}
                            alt="Details Icon"
                            style={{ width: 36 }}
                          />
                        </div>
                        <div className="overview-info">
                          <p className="info-title">{singleTile[1].title}</p>
                          {/* <GetStatus status={singleTile?.[1]?.status} /> */}
                          {getDocumentStatusNode(singleTile?.[1]?.status)}
                        </div>
                      </div>

                      <div className="info-start ms-auto">
                        {/* Only show Upload if not completed and no file uploaded */}
                        {singleTile[1].status !== "UNDER_REVIEW" &&
                          singleTile[1].status !== "APPROVED" &&
                          singleTile[1].status !== "REJECTED" &&
                          ((uploadKey === "Sales Forecast" &&
                            props?.valueSalesForecast === 1) ||
                          (uploadKey === "Audited Reports" &&
                            props?.valueAuditReport === 1) ||
                          (uploadKey === "VAT" &&
                            props?.valueVatReturns === 1) ? (
                            <Button
                              className="d-flex align-items-center"
                              variant="primary"
                              style={{
                                width: "110px",
                                opacity: 0.5,
                                pointerEvents: "none",
                              }}
                              disabled
                            >
                              Upload <LuUpload />
                            </Button>
                          ) : (
                            !isSwitchCompleted &&
                            !uploadStatus[uploadKey] && (
                              <Button
                                className="d-flex align-items-center"
                                variant="primary"
                                style={{ width: "110px" }}
                                onClick={() => {
                                  setPopUpTitles(singleTile[1].popUpTitle);
                                  setCurrentUploadKey(singleTile[1].uploadKey);
                                  setguidelines(singleTile[1].guidelines);
                                  setShow(true);
                                  setLoading(true);
                                  fetchDocList(
                                    singleTile[1].docInfoId,
                                    singleTile[1].uploadKey
                                  );
                                  setStatus(singleTile[1].status);
                                }}
                              >
                                Upload <LuUpload />
                              </Button>
                            )
                          ))}
                        {/* For Under Review status show View Button */}

                        {uploadStatus[uploadKey] && !isSwitchCompleted && (
                          <Button
                            className="d-flex align-items-center ms-2"
                            variant="primary"
                            onClick={() => {
                              fetchDocList(
                                singleTile[1].docInfoId,
                                singleTile[1].uploadKey
                              );
                              setPopUpTitles(singleTile[1].popUpTitle);
                              setCurrentUploadKey(singleTile[1].uploadKey);
                              setguidelines(singleTile[1].guidelines);
                              setStatus(singleTile[1].status);
                            }}
                          >
                            Edit <HiOutlinePencil />
                          </Button>
                        )}
                      </div>
                      {(uploadKey === "Sales Forecast" ||
                        uploadKey === "Audited Reports" ||
                        uploadKey === "VAT") && (
                        <div className="switch-btn-content d-flex w-100 justify-content-between">
                          <span className="m-0">
                            This is not applicable for me.
                          </span>
                          <Switch
                            className="switch-input-size"
                            value={singleTile[1].switchValue}
                            // {console.log("switch val", singleTile[1].switchValue) }
                            onChange={(val) => {
                              handleNotApplicableSwitch(
                                singleTile[1].docInfoId,
                                val
                              );
                              if (uploadKey === "Sales Forecast") {
                                props.setValueSalesForecast(val);
                              }
                              if (uploadKey === "Audited Reports") {
                                props.setValueAuditReport(val);
                              }
                              if (uploadKey === "VAT") {
                                props.setValueVatReturns(val);
                              }
                            }}
                            disabled={singleTile[1].status === "UNDER_REVIEW"}
                          />
                        </div>
                      )}
                      {uploadKey === "UnAudited Reports" && (
                        <span>{singleTile[1].bottomRowText}</span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        {/* End of Company Info Tiles */}

        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          className="Upload-trade-license"
          keyboard={false}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header
            closeButton
            className="d-flex justify-content-between py-3 px-4"
          >
            <Modal.Title>{popUpTitle}</Modal.Title>
          </Modal.Header>

          <Modal.Body
            className="p-4 modal-full-text"
            style={{ maxHeight: "60vh", overflowY: "auto" }}
          >
            <div className="guideline-sec mb-3">
              <h2 className="h6">Guidelines</h2>
              <ul className="mb-0">
                {guidelines.map((item, idx) => (
                  <li className="mb-1" key={idx}>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            {loadingModal ? (
              <LoaderModal />
            ) : (
              <>
                {!loadingModal &&
                  (uploadedFilesMap[currentUploadKey] || []).map(
                    (file, index) => (
                      <div
                        key={file._k || `${file.name}-${index}`}
                        className="file-upload-white-box d-flex align-items-start justify-content-between p-3 mb-3 bg-white"
                      >
                        <div className="d-flex align-items-start flex-grow-1">
                          <div className="me-3">
                            <div className="load-img-box rounded-circle p-1 d-flex align-items-center justify-content-center">
                              <img src={Document_show} alt="Document Icon" />
                            </div>
                          </div>
                          <div className="file-upload-box">
                            <div
                              className="file-title text-truncate mb-1"
                              style={{ maxWidth: "200px" }}
                              title={file.name}
                            >
                              {file.name}
                            </div>
                            <div className="file-sub-title text-muted small">
                              {getDaysAgoText(
                                file.date ? file.date : Date.now()
                              )}
                              {/* {getDaysAgoText(1756051200000)} */}
                            </div>
                            <div
                              className="file-preview mt-2 text-primary"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                if (file.isServerFile) {
                                  handlePreview(
                                    file.fileId,
                                    file.name,
                                    file.fileType
                                  );
                                } else if (file.fileObject) {
                                  const url = URL.createObjectURL(
                                    file.fileObject
                                  );
                                  setShow(!show);
                                  setCurrentPreview(url);
                                  setCurrentPreviewName(file.name);
                                  setCurrentPreviewType(file.fileObject.type);
                                  setShowPreview(true);
                                  setPreviewLoading(false);
                                  setPreviewError("");
                                }
                              }}
                            >
                              Tap to Preview
                            </div>
                          </div>
                        </div>

                        {/* status !== "UNDER_REVIEW" && */}

                        {
                          <button
                            className="btn btn-link text-danger p-0"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemoveFile(file);
                            }}
                            title="Delete"
                            aria-label="Delete file"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-trash3"
                              viewBox="0 0 16 16"
                            >
                              <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                            </svg>
                          </button>
                        }
                      </div>
                    )
                  )}

                {/* (Optional) uploader stays – remove if you only want server files */}
                {(uploadedFilesMap[currentUploadKey] || []) < 1 && (
                  <div
                    className="license-upload-section d-flex flex-column align-items-center justify-content-center p-4 mt-3"
                    style={{
                      borderStyle: "dashed",
                      cursor:
                        (uploadedFilesMap[currentUploadKey] || []).length > 0
                          ? "not-allowed"
                          : "pointer",
                      opacity:
                        (uploadedFilesMap[currentUploadKey] || []).length > 0
                          ? 0.5
                          : 1,
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (
                        (uploadedFilesMap[currentUploadKey] || []).length === 0
                      ) {
                        document.getElementById("fileUpload").click();
                      }
                    }}
                    role="button"
                    tabIndex="0"
                    onKeyDown={(e) => {
                      if (
                        e.key === "Enter" &&
                        (uploadedFilesMap[currentUploadKey] || []).length === 0
                      ) {
                        document.getElementById("fileUpload").click();
                      }
                    }}
                    onDragOver={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    onDrop={(e) => handleDrop(e, currentUploadKey)}
                  >
                    <img src={UploadDoc} alt="Upload Icon" />
                    <p className="mb-1 mt-2">Upload Document</p>
                    <small>(PDF supported)</small>
                    <input
                      id="fileUpload"
                      type="file"
                      accept=".pdf"
                      multiple={getAllowedFilesCount(currentUploadKey) > 1}
                      hidden
                      disabled={
                        (uploadedFilesMap[currentUploadKey] || []).length > 0
                      }
                      onChange={(e) => {
                        e.stopPropagation();
                        handleFileUpload(e, currentUploadKey);
                      }}
                    />
                  </div>
                )}
                {getAllowedFilesCount(currentUploadKey) > 1 &&
                  (uploadedFilesMap[currentUploadKey] || []).length > 0 &&
                  (uploadedFilesMap[currentUploadKey] || []).length <
                    getAllowedFilesCount(currentUploadKey) && (
                    <div
                      className="license-upload-section d-flex align-items-center justify-content-center p-4 mt-3 upload-license-box "
                      style={{
                        borderStyle: "dashed",
                        cursor: "pointer",
                        backgroundColor: "transparent",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (
                          (uploadedFilesMap[currentUploadKey] || []).length <
                          getAllowedFilesCount(currentUploadKey)
                        ) {
                          document.getElementById("fileUpload").click();
                        }
                      }}
                      role="button"
                      tabIndex="0"
                      onKeyDown={(e) => {
                        if (
                          e.key === "Enter" &&
                          (uploadedFilesMap[currentUploadKey] || []).length <
                            getAllowedFilesCount(currentUploadKey)
                        ) {
                          document.getElementById("fileUpload").click();
                        }
                      }}
                      onDragOver={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      onDrop={(e) => handleDrop(e, currentUploadKey)}
                    >
                      <img src={UploadDoc} alt="Upload Icon" />
                      <p className="mb-0 ms-2">Upload Document</p>
                      <input
                        id="fileUpload"
                        type="file"
                        accept=".pdf"
                        multiple={getAllowedFilesCount(currentUploadKey) > 1}
                        hidden
                        disabled={
                          (uploadedFilesMap[currentUploadKey] || []).length >=
                          getAllowedFilesCount(currentUploadKey)
                        }
                        onChange={(e) => {
                          e.stopPropagation();
                          handleFileUpload(e, currentUploadKey);
                        }}
                      />
                    </div>
                  )}
              </>
            )}
          {currentUploadKey === "AECB Report" && (
            <div className="mb-3">
              <div className="d-flex justify-content-between">
              <div className="d-flex align-items-center">
                <label className="mb-0 me-3">
                  Is this file password protected?
                </label>
                <Switch
                  className="switch-input-size"
                  value={isAecbPasswordProtected ? 1 : 0}
                  onChange={(val) => {
                    const nextValue = Number(val) === 1;
                    setIsAecbPasswordProtected(nextValue);
                    setAecbPasswordError("");
                    if (!nextValue) {
                      setAecbPassword("");
                      setIsAecbPasswordVisible(false);
                      setIsAecbPasswordEditable(true);
                    }
                    if (nextValue && hasProtectedAecbServerFile) {
                      setIsAecbPasswordEditable(false);
                    }
                  }}
                />
                <span className="ms-2">
                  {isAecbPasswordProtected ? "Yes" : "No"}
                </span>
                {hasProtectedAecbServerFile && (
                  <button
                    type="button"
                    className="btn btn-link p-0 ms-2"
                    onClick={handleRevealAecbPassword}
                    title="Reveal password"
                    aria-label="Reveal password"
                    disabled={isRevealingAecbPassword}
                  >
                    <FontAwesomeIcon icon={faEye} />
                  </button>
                )}
                </div>
                <div>
                {isAecbPasswordProtected && (
                  <button
                    type="button"
                    className="p-0 ms-2"
                    onClick={() => setIsAecbPasswordEditable(true)}
                    disabled={!isAecbPasswordVisible}
                    title="Edit password"
                    aria-label="Edit password"
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                )}
                </div>
              </div>
              <div className="mt-2">
                <input
                  type={isAecbPasswordVisible ? "text" : "password"}
                  className="form-control"
                  placeholder={
                    isAecbPasswordProtected
                      ? "Password Hidden"
                      : "Enter password"
                  }
                  value={aecbPassword}
                  disabled={!isAecbPasswordProtected || !isAecbPasswordEditable}
                  onChange={(e) => {
                    setAecbPassword(e.target.value);
                    if (aecbPasswordError) setAecbPasswordError("");
                  }}
                />
                {aecbPasswordError && (
                  <small className="text-danger">{aecbPasswordError}</small>
                )}
              </div>
            </div>
          )}
          </Modal.Body>

          <Modal.Footer className="p-3 border-0">
            <Button
              variant={
                (hasLocalFilesForCurrent || canSaveAecbPasswordOnly)
                  ? "primary active"
                  : "primary"
              }
              //variant={(uploadedFilesMap[currentUploadKey] || []).length > 0 ? "primary active" : "primary"}
              disabled={
                loadingModal ||
                (!hasLocalFilesForCurrent && !canSaveAecbPasswordOnly) ||
                (currentUploadKey === "AECB Report" &&
                  isAecbPasswordProtected &&
                  !aecbPassword.trim())
              }
              //   disabled={
              //   (uploadedFilesMap[currentUploadKey] || []).length < 1
              // }
              onClick={(e) => {
                e.stopPropagation();
                handleSubmit(currentUploadKey);
              }}
            >
              Save
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Preview Modal */}
        <Modal
          show={showPreview}
          onHide={closePreview}
          size="lg"
          centered
          backdrop="static"
          className="Upload-trade-license"
        >
          <Modal.Header closeButton className="justify-content-between">
            <Modal.Title className="text-truncate" style={{ maxWidth: 500 }}>
              {currentPreviewName || "Preview"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            className="text-center modal-full-text"
            style={{ maxHeight: "80vh", overflow: "auto" }}
          >
            {loadingModal && (
              <div style={{ minHeight: "200px" }}>
                <LoaderModal />
              </div>
            )}
            {previewError && (
              <div className="alert alert-warning py-2">{previewError}</div>
            )}

            {!previewLoading && !previewError && currentPreview && (
              <>
                {currentPreviewType.startsWith("image/") && (
                  <img
                    src={currentPreview}
                    alt="Preview"
                    style={{ maxWidth: "100%", height: "auto" }}
                  />
                )}

                {(currentPreviewType === "application/pdf" ||
                  currentPreviewType.endsWith("pdf")) && (
                  <iframe
                    src={currentPreview}
                    title="PDF Preview"
                    width="100%"
                    height="600px"
                    style={{ border: "none" }}
                  />
                )}

                {!currentPreviewType && (
                  // fallback: attempt inline
                  <iframe
                    src={currentPreview}
                    title="Document Preview"
                    width="100%"
                    height="600px"
                    style={{ border: "none" }}
                  />
                )}
              </>
            )}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
};

export default FinancialOverviewScreen;
